import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DatatableComponent } from './datatable.component';
import { TablecomponentsModule } from '../common/tablecomponents/tablecomponents.module';
import { tableHeaderFixerDirective } from '../common/directives/table-header-fixer.directive';
import { masterConf } from './datatable-master-config';

@NgModule({
  declarations: [DatatableComponent, tableHeaderFixerDirective],
  imports: [
    CommonModule,
    TablecomponentsModule
  ],
  exports:[DatatableComponent, tableHeaderFixerDirective]
})
export class DatatableModule { 

  toolBarElementOrder: object = {
    LEFT: 'order-md-1',
    CENTER: 'order-md-2',
    RIGHT: 'order-md-3'
  }

  getOrderText(alignment: string){
    return this.toolBarElementOrder[alignment.toUpperCase()];
  }

  getTableMasterConfiguration(){
    return masterConf;
  }

  /**
   * data: Table data.Array<Object>
   * keyPath: initially empty
   * columnConfig: contains column to show and their configuration. e.g 
   * {
   *  show['a','b'], 
   *  properties:{
   *    'a':{
   *      hideable: false,
          type: "LOCATION",
          displayAs: "",
          stopAt: "STATION",
          append: "locUuid",
          class: 'font-weight-bold',    //class that is to be applied to header
          copyToRows: false             //if true, same class will be applied to all rows of that column
   *    }
   *  }
   * }
   * @param data 
   * @param keyPath
   * @param columnConfig 
   * @param colFilter 
   */
  getTableHeaderConfiguration(tableData: any, keyPath: string, columnConfig: Object, colFilter:boolean){
    if(tableData == undefined) return;
    
    let data = JSON.parse(JSON.stringify(tableData,  function(k, v) { return v === undefined ? null : v; }));
    if(data instanceof Array)
      data = this.getHeaderSkeleton(data, {}); 
      
    let colList = this.prepareHeader(data, keyPath, columnConfig, colFilter);
    
    /**
     * Sort the headers
     */
    /**
     * Sort response so that columns with no child data comes first
     */
    let necessarySortedColumns = [];
    let optionalSortedColumns = [];
    let columnsWithChild = [];
    colList.forEach(element => {
      if(element['childs'] == undefined){
        if(columnConfig['show'].indexOf(element['jsonKey']['path'].split("##")[0]) == -1)
          optionalSortedColumns.push(element);
        else
          necessarySortedColumns.splice(columnConfig['show'].indexOf(element['jsonKey']['path'].split("##")[0]), 0, element);
      }
      else
        columnsWithChild.push(element);
    });
    
    necessarySortedColumns = necessarySortedColumns.concat(optionalSortedColumns, columnsWithChild);
    return necessarySortedColumns;
  }

  prepareHeader(data: any, keyPath: string, columnConfig: Object, colFilter:boolean){
    if(data == undefined || columnConfig == undefined) return;

    let colList = [];
    if(data instanceof Array)
      data = data[0]; 
      
    for(let key in data){
      let col = {};
      col['name'] = (columnConfig['properties'] != undefined && columnConfig['properties'][key] && columnConfig['properties'][key]['displayAs'] != undefined)?columnConfig['properties'][key]['displayAs']:key;
      col['class'] = (columnConfig['properties'] != undefined && columnConfig['properties'][key] && columnConfig['properties'][key])? columnConfig['properties'][key]['class']:'';
      col['copyToRows'] = (columnConfig['properties'] != undefined && columnConfig['properties'][key] && columnConfig['properties'][key]['copyToRows']);
      if(data[key] instanceof Object){
        if(columnConfig['show'] != undefined && columnConfig['show'].length == 2){
          col = {...col, ...this.prepareHeader(data[key], (keyPath + ((keyPath.length > 0)?".":"") + key), columnConfig, colFilter)[0]};
          col['name'] = (columnConfig['properties'] != undefined && columnConfig['properties'][key] && columnConfig['properties'][key]['displayAs'] != undefined)?columnConfig['properties'][key]['displayAs']:key;
        }
        else
          col['childs'] = this.prepareHeader(data[key], (keyPath + ((keyPath.length > 0)?".":"") + key), columnConfig, colFilter);
      }else{
        if(colFilter && (columnConfig == undefined || columnConfig['show'].length == 0 || columnConfig['show'].indexOf(key) == -1)) continue;
        col['dataType'] = (columnConfig['properties'] != undefined && columnConfig['properties'][key] != undefined && columnConfig['properties'][key]['type'] != undefined)?columnConfig['properties'][key]['type']:(typeof data[key] === 'number')?"NUMBER":"TEXT";
        col['defaultValue'] = "-";
        col['jsonKey'] = {}
        col['jsonKey']['path'] = (keyPath + ((keyPath.length > 0)?".":"") + key)
        /**
         * TODO: fix the uuid field, it should be consistent. If possible move this field out of this method.
         */
        if(columnConfig['properties'] != undefined && columnConfig['properties'][key] != undefined
          && columnConfig['properties'][key]['append'] != undefined)
          col['jsonKey']['path'] = col['jsonKey']['path'] + "##" + ((keyPath + ((keyPath.length > 0)?".":"") + columnConfig['properties'][key]['append']))
      }
      
      colList.push(col);
    }

    return colList;
  }

  /**
   * Returns the skeleton of the header. i.e all the key - value pairs in the data.
   * It iterates through entire dataset and ensures that none of the pairs are missed.
   */
  getHeaderSkeleton(data: any, objectResult: Object){
    if(data == undefined) return data;

    let result = {};

    if(data instanceof Array){
      data.forEach(element =>{
        for(let key in element){
          if(result[key] == undefined)
            result[key] = element[key];
          
          if(element[key] != undefined && element[key] instanceof Object){
            result[key] = this.getHeaderSkeleton(element[key], result[key]);
          }
        }
      });
    }else{
      for(let key in data){
        objectResult[key] = data[key];
      
        if(data[key] != undefined && data[key] instanceof Object){
          objectResult[key] = this.getHeaderSkeleton(data[key], objectResult[key]);
        }
      }
      return objectResult;
    }

    return result;
  }
}
